import { Link } from 'react-router-dom';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $profileFeatureStore } from '@lib/store';
import { RoutePaths } from '@shared/utils';
import { type CardsResponse, CardStatus } from '@shared/api/rest/cards';
import { Tabs, TabsItem } from '@widgets';
import { CardGridViewItem } from '../cardGridViewItem';
import { NoData } from '@shared/widgets';

interface Props {
  cards: CardsResponse[];
  total: number;
  activeTab?: CardStatus;
  setActiveTab: (status?: CardStatus) => void;
}

export const RelatedCards = (props: Props) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  return (
    <>
      {props.total > 0 ? (
        <>
          <div className='flex items-center justify-between !flex-nowrap'>
            <Tabs className='p-0'>
              <TabsItem text='All' active={props.activeTab == undefined} onClick={() => props.setActiveTab(undefined)} />
              <TabsItem text='Active' active={props.activeTab == CardStatus.ACTIVE} onClick={() => props.setActiveTab(CardStatus.ACTIVE)} />
              <TabsItem text='Closed' active={props.activeTab == CardStatus.CLOSED} onClick={() => props.setActiveTab(CardStatus.CLOSED)} />
              <TabsItem text='Blocked' active={props.activeTab == CardStatus.BLOCKED} onClick={() => props.setActiveTab(CardStatus.BLOCKED)} />
              <TabsItem
                text='Delinquent'
                active={props.activeTab == CardStatus.DELINQUENT}
                onClick={() => props.setActiveTab(CardStatus.DELINQUENT)}
              />
              <TabsItem
                text={CardStatus.INACTIVE}
                active={props.activeTab == CardStatus.INACTIVE}
                onClick={() => props.setActiveTab(CardStatus.INACTIVE)}
              />
              <TabsItem text='Frozen' active={props.activeTab == CardStatus.FROZEN} onClick={() => props.setActiveTab(CardStatus.FROZEN)} />
            </Tabs>
          </div>
          <div
            className={clsx(
              'pt-5 rounded-tl-none rounded-tr-2 rounded-br-2 rounded-bl-2 bg-white dark:bg-soft-black flex flex-wrap',
              props.cards.length < 0 && 'justify-center flex-nowrap',
              props.cards?.length === 0 && 'justify-center items-center',
            )}
          >
            {props.cards.length > 0 &&
              props.cards.map((card, idx) => {
                const viewCardDetails = profileFeatureStore.data?.cardFlows?.find((feature) => feature.cardId === card.cardId)?.viewCardDetails;
                return (
                  <Link key={idx} to={RoutePaths.card.onNavigate(card.cardId)} onClick={(e) => viewCardDetails === false && e.preventDefault()}>
                    <CardGridViewItem card={card} />
                  </Link>
                );
              })}
            <div className={props.cards?.length === 0 ? 'w-full text-center' : 'ml-5'}>
              {props.cards?.length === 0 && <NoData text='No related records' />}
            </div>
          </div>
        </>
      ) : (
        <NoData text='No related records' />
      )}
    </>
  );
};
